import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { GameRouteSelector, GameSelector, GamingExternalState, GamingRoutes } from "@obg/gaming.external";
import { CoreState } from "@obg/ngx.core";
import { RouteAction, RouteLink } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";
import { map, switchMap, take, tap, timeout } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class MyOffersGameService {
	constructor(
		private store: Store<CoreState & GamingExternalState>,
		private gameSelector: GameSelector,
		private gameRouteSelector: GameRouteSelector
	) {}

	launchGame$(gameId: string): Observable<RouteLink | null> {
		return this.store.pipe(
			select(this.gameSelector.getByPrimaryVariantId(gameId)),
			ignoreNil(),
			timeout(5000),
			take(1),
			switchMap((game) => this.gameRoute$(game.id)),
			tap((gameRoute) => {
				if (!gameRoute) {
					return;
				}
				this.store.dispatch(
					RouteAction.navigate(gameRoute.route as string, gameRoute.params, gameRoute.extras)
				);
			})
		);
	}

	private gameRoute$(gameId: string): Observable<RouteLink | null> {
		return this.store.pipe(
			select(this.gameRouteSelector.getRouteLinkByGameId(gameId, GamingRoutes.GameLauncher)),
			ignoreNil(),
			take(1),
			map((resolvedRouteLink) => (resolvedRouteLink?.route ? resolvedRouteLink : null))
		);
	}
}
